module.exports = __webpack_public_path__ + "vrplayerstatic/media/autoplay-start.9196bfb1.svg";